﻿var digitalvalidationEId = (function () {
    //Hide the page-next button if mit-id button is shown
    var btn = document.getElementById("digitalvalidation-next-eid");
    if (btn) {
        document.getElementById("digitalvalidation-next").style.visibility = "hidden"; 
    }
})();